// import AssetService from './AssetServiceWorker'
import AssetService from './AssetService'

export default AssetService
